<script>
import Sidebar from '@/components/shared/base/Sidebar.vue';
import Topbar from '@/components/shared/base/topbar/Topbar.vue';
import LoadingDots from '@/components/shared/LoadingDots.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AppPage',

  props: {
    isApiPage: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    Sidebar,
    Topbar,
    LoadingDots,
  },

  computed: {
    ...mapState('settings', ['isPageLoading', 'isSidebarOpen']),
  },

  methods: {
    ...mapActions('settings', ['closeSidebar']),
  },
};
</script>

<template>
  <div class="page-wrapper">
    <Topbar :isApiPage="isApiPage" />
    <Sidebar :isApiPage="isApiPage" />

    <div class="loading-dots fade" :class="{ show: isPageLoading }">
      <LoadingDots color="dark" />
    </div>

    <router-view class="fade" :class="{ show: !isPageLoading }" />

    <div class="overlay" v-if="isSidebarOpen" @click="closeSidebar()" />
  </div>
</template>

<style lang="scss">
.page-wrapper {
  margin-top: $topbar-height-small;

  @include tablet-large {
    margin-top: $topbar-height-large;
    margin-left: $left-sidebar-width;
  }
}

.loading-dots {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  max-width: $page-width;
  margin-top: $topbar-height-small;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: -1;

  @include tablet-large {
    margin-left: $left-sidebar-width;
    margin-top: $topbar-height-large;
  }
}

.fade {
  opacity: 0;

  &.show {
    transition: $transition;
    opacity: 1;
  }
}

.overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: black;
  z-index: 997;
  opacity: 0.4;

  @include tablet-large {
    display: none;
  }
}

@media print {
  .topbar {
    display: none;
  }

  .page-wrapper {
    margin: 0;
  }
}
</style>
